//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { thirdOrderStateOption } from '../static';
import throttle from '@/utils/throttle';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import * as thirdOrderApi from '@/api/thirdOrderApi.js';
import transformState from '@/utils/transformState.js';
import ThirdOrderDetail from './thirdOrderDetail.vue';
import { categoryApi } from '@/api/store';
export default {
  components: {
    ThirdOrderDetail: ThirdOrderDetail
  },
  data: function data() {
    return {
      thirdOrderStateOption: thirdOrderStateOption,
      selectTagList: [],
      // 选择标签
      brandOption: [],
      // 品牌
      supplierOption: [],
      // 销售商
      merCateList: [],
      // 分类
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      // 分类

      constants: this.$constants,
      userOption: [{
        value: 1,
        name: '当前登陆人'
      }],
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      editDialogConfig: {
        visible: false,
        editId: 0,
        isEdit: 0 // 0=add 1=edit
      },
      listLoading: true,
      categoryTreeData: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.initSearch();
    this.handlerGetListData(this.listPram);
  },
  methods: {
    throttle: throttle,
    transformState: transformState,
    initSearch: function initSearch() {
      this.searchBrand();
      this.getCategorySelect();
      this.searchSupplier();
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      thirdOrderApi.ListArticle(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 品牌查询
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      suplierCouponsApi.getAllBrand(keyword).then(function (res) {
        _this3.brandOption = res && res.length && res.map(function (item) {
          var _ref = item || {},
            id = _ref.id,
            brandName = _ref.brandName;
          return {
            id: id,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(id)
          };
        }) || [];
      });
    },
    // 供应商查询
    searchSupplier: function searchSupplier() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierOption = [];
      suplierCouponsApi.getAllSupplier(keyword).then(function (res) {
        _this4.supplierOption = res || [];
      });
    },
    // 搜索供应商
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this5 = this;
      this.throttle(function () {
        _this5.searchSupplier(data);
      }, 300)();
    },
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this6 = this;
      this.throttle(function () {
        _this6.searchBrand(data);
      }, 300)();
    },
    _transportTem: function _transportTem(related) {
      var _list;
      if (!related) return;
      var list = [];
      try {
        list = JSON.parse(related);
      } catch (error) {}
      ;
      return (_list = list) === null || _list === void 0 ? void 0 : _list.join(',');
    }
  }
};